<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <Radio
    id="personal-info-salutation"
    name="salutation"
    :label="t('tocco.registration.personalInfo.salutation')"
    :options="[
      { value: 2, label: t('tocco.registration.personalInfo.salutationOptions.2') },
      { value: 1, label: t('tocco.registration.personalInfo.salutationOptions.1') },
      { value: 66, label: t('tocco.registration.personalInfo.salutationOptions.66') },
    ]"
    :required="true"
  />

  <div class="form-section--2-cols">
    <Input
      id="personal-info-firstname"
      name="firstname"
      :label="t('tocco.registration.personalInfo.firstname')"
      :required="true"
    />
    <Input
      id="personal-info-lastname"
      name="lastname"
      :label="t('tocco.registration.personalInfo.lastname')"
      :required="true"
    />
  </div>

  <Email id="personal-info-email" name="email" :label="t('tocco.registration.personalInfo.email')" :required="true" />
</template>
